export function getFolderPaths(folders) {
  const paths = [];

  function traverse(node, path) {
    const currentPath = path ? `${path}/${node.label}` : node.label;
    if (node.children?.length > 0) {
      node.children.forEach((child) => traverse(child, currentPath));
    } else {
      paths.push({ complete_path: currentPath });
    }
  }

  folders.forEach((folder) => traverse(folder, ''));
  return paths;
}
